import React from "react";

const TemarioDiplomaturaNutricionDeportiva = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Introducción a la nutrición"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Establecer los conocimientos científicos básicos actualizados sobre nutrición"}</span></li>
                <li><span className="fw-light">{"Bases moleculares de la nutrición"}</span></li>
                <li><span className="fw-light">{"Actualización en la composición de alimentos Tablas de composición de alimentos Nuevos alimentos"}</span></li>
                <li><span className="fw-light">{"Nutrientes funcionales"}</span></li>
                <li><span className="fw-light">{"Probióticos y Prebióticos El agua y la correcta hidratación"}</span></li>
                <li><span className="fw-light">{"Nuevo etiquetado alimentario en Argentina"}</span></li>
            </ul>
            <br /><br />
            <b>{"Metabolismo digestivo"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Establecer los conocimientos científicos sobre el metabolismo digestivo"}</span></li>
                <li><span className="fw-light">{"Cómo funciona nuestro metabolismo"}</span></li>
                <li><span className="fw-light">{"Fisiología digestiva"}</span></li>
                <li><span className="fw-light">{"Regulación de la alimentación: Apetito y saciedad Sistema circadiano: ¿El horario de la comida es la clave"}</span></li>
            </ul>
            <br /><br />
            <b>{"Valoración del estado nutricional"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Brindar herramientas para la evaluación del estado nutricional"}</span></li>
                <li><span className="fw-light">{"Bioenergética y nutrición"}</span></li>
                <li><span className="fw-light">{"Necesidades energéticas"}</span></li>
                <li><span className="fw-light">{"Gasto energético diario basal"}</span></li>
                <li><span className="fw-light">{"Valoración del estado nutricional"}</span></li>
                <li><span className="fw-light">{"Análisis de la composición corporal por antropometría"}</span></li>
                <li><span className="fw-light">{"Nuevos métodos de evaluación. Análisis InBody"}</span></li>
                <li><span className="fw-light">{"Actualización en requerimientos nutricionales e ingestas recomendadas Alimentación en el adulto sano. Dietas de moda"}</span></li>
            </ul>
            <br /><br />
            <b>{"Fisiología muscular y metabólica relacionada con el ejercicio"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Establecer los conocimientos científicos básicos actualizados sobre la fisiología del deporte"}</span></li>
                <li><span className="fw-light">{"Estructura del músculo y tipos de fibras musculares"}</span></li>
                <li><span className="fw-light">{"La fibra muscular"}</span></li>
                <li><span className="fw-light">{"Fibra muscular tipo I"}</span></li>
                <li><span className="fw-light">{"Fibras musculares tipo II"}</span></li>
                <li><span className="fw-light">{"Concepto de umbral láctico ATP y metabolismo de los fosfágenos"}</span></li>
                <li><span className="fw-light">{"Rutas metabólicas para la resíntesis de ATP durante el ejercicio"}</span></li>
                <li><span className="fw-light">{"Metabolismo de los fosfágenos"}</span></li>
            </ul>
            <br /><br />
            <b>{"Metabolismo en la práctica deportiva"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Establecer los conocimientos científicos básicos actualizados sobre la nutrición en sí aplicada al deporte"}</span></li>
                <li><span className="fw-light">{"Fisiología del ejercicio Adaptación fisiológica a los distintos tipos de ejercicio Adaptación metabólica al ejercicio"}</span></li>
                <li><span className="fw-light">{"Regulación y control Valoración de las necesidades energéticas y del estado nutricional del deportista"}</span></li>
            </ul>
            <br /><br />
            <b>{"Suplementos deportivos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Ayudas Ergogénicas: suplementos nutricionales y actividad física"}</span></li>
                <li><span className="fw-light">{"Uso de sustancias anabólicas"}</span></li>
                <li><span className="fw-light">{"Suplementos Nutricionales: Estudios científicos"}</span></li>
                <li><span className="fw-light">{"Marco Legal de los suplementos nutricionales"}</span></li>
                <li><span className="fw-light">{"Suplementos Proteicos: industrialización, obtención y consumo"}</span></li>
                <li><span className="fw-light">{"Cuando es necesaria la suplementación deportiva"}</span></li>
            </ul>
            <br /><br />
            <b>{"Alimentación aplicada al deporte"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Establecer los conocimientos científicos básicos actualizados sobre los alimentos aplicados al deporte"}</span></li>
                <li><span className="fw-light">{"Metabolismo de los hidratos de carbono"}</span></li>
                <li><span className="fw-light">{"Movilización de los hidratos de carbono durante el ejercicio"}</span></li>
                <li><span className="fw-light">{"Tipos de glucólisis"}</span></li>
                <li><span className="fw-light">{"Metabolismo de los lípidos"}</span></li>
                <li><span className="fw-light">{"Lipólisis"}</span></li>
                <li><span className="fw-light">{"Oxidación de grasa durante el ejercicio"}</span></li>
                <li><span className="fw-light">{"Cuerpos cetónicos"}</span></li>
                <li><span className="fw-light">{"Metabolismo de las proteínas"}</span></li>
                <li><span className="fw-light">{"Metabolismo del amonio"}</span></li>
                <li><span className="fw-light">{"Oxidación de aminoácidos"}</span></li>
                <li><span className="fw-light">{"Bioenergética mixta de las fibras musculares"}</span></li>
                <li><span className="fw-light">{"Fuentes energéticas y su relación con el ejercicio"}</span></li>
                <li><span className="fw-light">{"Uso de una u otra fuente de energía durante el ejercicio"}</span></li>
            </ul>
            <br /><br />
            <b>{"Vegetarianismo y veganismo"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Brindar los conceptos actualizados sobre la alimentación en Dieta vegetariana y vegana aplicada al deporte"}</span></li>
                <li><span className="fw-light">{"Vegetarianismo y veganismo en la historia del deporte"}</span></li>
                <li><span className="fw-light">{"Deportista vegano Deportista vegetariano"}</span></li>
                <li><span className="fw-light">{"Errores frecuentes"}</span></li>
                <li><span className="fw-light">{"Balance energético"}</span></li>
                <li><span className="fw-light">{"Consumo de proteína y fuentes de proteína"}</span></li>
                <li><span className="fw-light">{"Vitaminas y minerales. Aporte correcto de Vitamina B12"}</span></li>
            </ul>
            <br /><br />
            <b>{"Generalidades de la nutrición aplicada a enfermedades endocrino-metabólicas"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Conocer las pautas para aplicar el deporte en patologías específicas"}</span></li>
                <li><span className="fw-light">{"Diabetes tipo 2"}</span></li>
                <li><span className="fw-light">{"Obesidad"}</span></li>
                <li><span className="fw-light">{"Hipertensión arterial"}</span></li>
                <li><span className="fw-light">{"Dislipidemias"}</span></li>
            </ul>
            <br /><br />
            <b>{"Nutrición, deporte y envejecimiento"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Brindar la actualización sobre antienvejecimiento en el deporte"}</span></li>
                <li><span className="fw-light">{"Dinapenia y sarcopenia"}</span></li>
                <li><span className="fw-light">{"Envejecimiento"}</span></li>
                <li><span className="fw-light">{"Definición de envejecimiento"}</span></li>
                <li><span className="fw-light">{"¿Podemos considerar al envejecimiento una enfermedad"}</span></li>
                <li><span className="fw-light">{"Terapéutica nutricional hoy y a futuro"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaNutricionDeportiva;
